import { render, staticRenderFns } from "./StatusesModal.vue?vue&type=template&id=7a8c6569&"
import script from "./StatusesModal.vue?vue&type=script&lang=js&"
export * from "./StatusesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports